module.exports = __webpack_public_path__ + "static/media/conce_bitcoin_coins.54f308c6.png";